import React, { useEffect } from "react";
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import Underline from "@tiptap/extension-underline";
import Link from "@tiptap/extension-link";
import TextAlign from "@tiptap/extension-text-align";
import Highlight from "@tiptap/extension-highlight";
import "./PublicationEditor.css";
import Toolbar from "./Toolbar";
import Image from "@tiptap/extension-image";
import DropCap from "./extensions/DropCap";

import RichTextTable from
  "./extensions/RichTextTable";

import RichTextShape from
  "./extensions/RichTextShape";

import {
  TableRow
} from "@tiptap/extension-table/row";

import {
  TableHeader
} from "@tiptap/extension-table/header";

import {
  TableCell
} from "@tiptap/extension-table/cell";

import {
  TextStyle,
  FontSize,
  Color,
} from "@tiptap/extension-text-style";

import sanitizeRichHtml from
  "../../utils/sanitizeRichHtml";

function PublicationEditor({ value, onChange }) {

  const editor = useEditor({
    extensions: [
    StarterKit,
    TextStyle,
    FontSize,
    Color,
    Underline,
    Highlight.configure({
      multicolor: true,
    }),
    DropCap,
    RichTextShape,
    Image.configure({
      inline: false,
      allowBase64: false,

      HTMLAttributes: {
        class: "editor-uploaded-image"
      }
    }),

    RichTextTable.configure({
      resizable: true,
      lastColumnResizable: true,
      allowTableNodeSelection: true,

      HTMLAttributes: {
        class: "rich-text-table"
      }
    }),

    TableRow,
    TableHeader,
    TableCell,

    Link.configure({
      openOnClick: false,
      autolink: true,
      linkOnPaste: true,
    }),
    TextAlign.configure({
      types: ["heading", "paragraph"],
    }),
  ],

    content:
  sanitizeRichHtml(
    value || ""
  ),

    onUpdate: ({ editor }) => {
      onChange(editor.getHTML());
    },
  });

  useEffect(() => {
    if (
      editor &&
      value !== editor.getHTML()
    ) {
      editor.commands.setContent(
  sanitizeRichHtml(
    value || ""
  )
);
    }
  }, [value, editor]);

  if (!editor) {
    return null;
  }

  return (
    <div className="publication-editor">

        <Toolbar editor={editor} />

        <EditorContent editor={editor}/>

    </div>
  );
}

export default PublicationEditor;